import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core';
import moment from 'moment';

//- ui
import Cell from '../Cell';
import WorkDay from '../Cells/WorkDay';
import ShiftCell from '../Cells/ShiftCell';

const styles = () => {
	return {
		editHover: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			transition: '0.3s',
			cursor: 'pointer',
			border: '1px solid rgba(255,255,255,.1)',
			zIndex: 100,
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		driverCell: {
			padding: '4px 7px',
		},
		slotOpen: {
			whiteSpace: 'noWrap',
			// backgroundColor : openColor,
			color: '#EA7416',
			fontSize: 14,
		},
		slotFull: {
			whiteSpace: 'noWrap',
			fontSize: 14,
		},
		subSlot: {
			fontSize: 12,
			color: '#666',
		},
	};
};

class FleetCalendarRow extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			dateColumns,
			numberOfDays,
			classes,
			row,
			userMap,
			shiftMap,
			locationMap,
			isOdd,
			updateUserAssignment,
			onWorkDayUpdate,
		} = this.props;

		if (_.isEmpty(row)) {
			return;
		}

		const {
			key,
			//equipmentAssignment,
			user,
			//activeUserAssignment,
			inactiveUserAssignment,
			locationId,
			shiftId,
			shiftTime,
			userWorkDaysByDate,
		} = row;

		//- Used when sorting by terminal

		let subLine = '';
		if (inactiveUserAssignment) {
			const { userId, endDate } = inactiveUserAssignment;
			const inactiveUser = userMap[userId] || {
				firstName: 'Missing',
				lastName: 'Missing',
			};
			subLine =
				`${inactiveUser.firstName.charAt(0)} ${inactiveUser.lastName} ` +
				`last day ${moment(endDate).format('M/D')}`;
		}

		let userTitle = user && user.title ? user.title : null;
		if (!userTitle && user.role === 'driver') {
			userTitle = `Driver${user.geoTabName ? `: ${user.geoTabName}` : ''}`;
		}

		return (
			<Fragment key={key}>
				<tr key={key}>
					<Cell isOdd={isOdd}>
						<div className={classes.editHover} onClick={updateUserAssignment} />
						<div className={classes.driverCell}>
							{!user && <div className={classes.slotOpen}>- open -</div>}

							{!!user && (
								<div className={classes.slotFull}>
									{user.firstName} {user.lastName}
								</div>
							)}
							{!!userTitle && <div className={classes.subSlot}>{userTitle}</div>}

							{!!subLine && <div className={classes.subSlot}>{subLine}</div>}
						</div>
					</Cell>

					<ShiftCell
						key={key}
						user={user}
						shiftId={shiftId}
						isOdd={isOdd}
						shiftTime={shiftTime}
						assignedToUser={undefined}
					/>

					{dateColumns.map(({ date }) => {
						const userWorkDays = userWorkDaysByDate[date] || [];

						//- Happens on transfers
						if (_.isEmpty(userWorkDays)) {
							return (
								<Cell key={date} numberOfDays={numberOfDays} isOdd={isOdd}>
									<div style={{ padding: 5, color: '#aaa', fontSize: 12, textAlign: 'center' }}>
										X
									</div>
								</Cell>
							);
						}

						//- Might be multiple "WorkDays" per day for things like equipment
						return (
							<Cell numberOfDays={numberOfDays} key={date} isOdd={isOdd}>
								{userWorkDays.map((workDay) => {
									const { workDayId } = workDay;
									return (
										<div key={workDayId}>
											<div
												className={classes.editHover}
												onClick={() => {
													onWorkDayUpdate(workDayId);
												}}
											/>
											<WorkDay
												workDay={workDay}
												numberOfDays={numberOfDays}
												userMap={userMap}
												shiftMap={shiftMap}
												locationMap={locationMap}
												assignedLocationId={locationId}
											/>
										</div>
									);
								})}
							</Cell>
						);
					})}
				</tr>
			</Fragment>
		);
	}
}

FleetCalendarRow.propTypes = {
	classes: PropTypes.object.isRequired,
	updateUserAssignment: PropTypes.func.isRequired,
};
export default withStyles(styles)(FleetCalendarRow);
